import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Phone } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Card, CardBody } from '../components/ui/Card';
export function FleetVans() {
  // Generate 20 vans
  const vans = Array.from({
    length: 20
  }).map((_, i) => {
    const models = ['Toyota Sienna', 'Chrysler Pacifica', 'Honda Odyssey', 'Dodge Grand Caravan', 'Ford Transit', 'Mercedes Sprinter', 'Ram ProMaster', 'Kia Sedona'];
    const years = ['2022', '2023', '2024', '2025'];
    const prices = [50, 55, 60, 65, 70, 75, 80];
    const model = models[i % models.length];
    const year = years[i % years.length];
    const price = prices[i % prices.length];
    const imageIds = ['1559416523-140ddc3d238c', '1570733577524-3a047079e80d', '1609521263047-f8f205293f24', '1543465077-db45d34b88a5', '1513311068273-200622430bd5'];
    const imageId = imageIds[i % imageIds.length];
    return {
      id: i,
      name: `${model} WAV`,
      year,
      price: `$${price}/hr`,
      description: `Spacious ${model} equipped with ADA-compliant ramps, lowered floors, and advanced Q-Straint wheelchair securement systems.`,
      image: `https://images.unsplash.com/photo-${imageId}?w=600&h=400&fit=crop&q=80&sig=${i}`
    };
  });
  return <div className="bg-warm-50 min-h-screen pb-20" data-id="element-518">
      <div className="bg-white py-12 border-b border-warm-200 mb-12" data-id="element-519">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-520">
          <Link to="/fleet" className="inline-flex items-center text-primary-600 hover:text-primary-800 font-medium mb-6 transition-colors" data-id="element-521">
            <ArrowLeft className="w-4 h-4 mr-2" data-id="element-522" /> Back to Fleet Overview
          </Link>
          <h1 className="text-4xl font-extrabold text-black mb-4" data-id="element-523">
            Wheelchair Accessible Vans
          </h1>
          <p className="text-lg text-warm-600 max-w-3xl" data-id="element-524">
            Browse our complete inventory of modified minivans and full-size
            vans designed for maximum space and accessibility.
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-525">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-526">
          {vans.map(vehicle => <Card key={vehicle.id} className="rounded-2xl shadow-md overflow-hidden hover:shadow-xl transition-shadow duration-300 border-none bg-white flex flex-col h-full" data-id="element-527">
              <img src={vehicle.image} alt={vehicle.name} className="w-full h-48 object-cover" data-id="element-528" />
              <CardBody className="p-6 flex flex-col flex-grow" data-id="element-529">
                <div className="flex justify-between items-start mb-2" data-id="element-530">
                  <h3 className="text-xl font-bold text-black leading-tight" data-id="element-531">
                    {vehicle.name}
                  </h3>
                  <span className="bg-warm-100 text-warm-800 text-xs font-bold px-2 py-1 rounded" data-id="element-532">
                    {vehicle.year}
                  </span>
                </div>
                <p className="text-primary-600 font-bold text-lg mb-3" data-id="element-533">
                  {vehicle.price}
                </p>
                <p className="text-warm-600 text-sm mb-6 flex-grow" data-id="element-534">
                  {vehicle.description}
                </p>
                <div className="flex gap-3 mt-auto items-stretch" data-id="element-535">
                  <Link to="/booking" className="flex-1 flex" data-id="element-536">
                    <Button variant="primary" size="sm" className="w-full h-full" data-id="element-537">
                      Call
                    </Button>
                  </Link>
                  <Link to="/booking" className="flex-1 flex" data-id="element-538">
                    <Button variant="outline" size="sm" className="w-full h-full border-2" data-id="element-539">
                      Hire Now
                    </Button>
                  </Link>
                </div>
              </CardBody>
            </Card>)}
        </div>

        <div className="mt-20 bg-black rounded-3xl p-10 text-center text-white shadow-2xl" data-id="element-540">
          <h2 className="text-3xl font-bold mb-4" data-id="element-541">
            Need help choosing the right van?
          </h2>
          <p className="text-warm-400 mb-8 max-w-2xl mx-auto" data-id="element-542">
            Our mobility specialists are available 24/7 to help you find the
            perfect vehicle for your specific needs.
          </p>
          <a href="tel:5551234567" data-id="element-543">
            <Button size="lg" className="bg-primary-600 hover:bg-primary-700 text-white border-none" data-id="element-544">
              <Phone className="w-5 h-5 mr-2" data-id="element-545" /> Call (555) 123-4567
            </Button>
          </a>
        </div>
      </div>
    </div>;
}